import { render, staticRenderFns } from "./RecallFilter.vue?vue&type=template&id=0b8ae51e&"
import script from "./RecallFilter.vue?vue&type=script&lang=js&"
export * from "./RecallFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports